import { doc, getDoc, serverTimestamp, setDoc } from "firebase/firestore";
import { db } from "../../../firebaseConfig";
import { ROLE_DASHBOARD_PATH } from "./nafedRoles";

export async function createNafedUserProfile(user, data) {
  await setDoc(
    doc(db, "nafed_users", user.uid),
    {
      uid: user.uid,
      email: user.email || data.email,
      name: data.name || "",
      mobile: data.mobile || "",
      role: data.role || "",
      state: data.state || "",
      district: data.district || "",
      organizationName: data.organizationName || "",
      status: data.role === "HEAD_OFFICE" ? "APPROVED" : "PENDING",
      isActive: data.role === "HEAD_OFFICE",
      createdAt: serverTimestamp(),
      updatedAt: serverTimestamp(),
    },
    { merge: true }
  );
}

export async function getNafedUserProfile(uid) {
  const snap = await getDoc(doc(db, "nafed_users", uid));
  return snap.exists() ? { id: snap.id, ...snap.data() } : null;
}

export function getNafedRedirectPath(profile) {
  return ROLE_DASHBOARD_PATH[profile?.role] || "/nafed";
}